import { c as _c } from "react/compiler-runtime";
// Centralised route table. Every page lives under src/pages/<name>.tsx and
// renders inside <SiteLayout /> (persistent header + footer). The inspiration
// feed is the landing page at "/"; the product catalog lives at "/catalog".
import { Navigate, Route, Routes } from "react-router";
import { SiteLayout } from "@/components/layout/site-layout";
import { BecomeSellerPage } from "./pages/become-seller";
import { CartPage } from "./pages/cart";
import { CatalogPage } from "./pages/catalog";
import { ContactsPage } from "./pages/contacts";
import { DeliveryPage } from "./pages/delivery";
import { PaymentPage } from "./pages/payment";
import { ReturnsPage } from "./pages/returns";
import { CheckoutPage } from "./pages/checkout";
import { CheckoutSuccessPage } from "./pages/checkout-success";
import { FeedPage } from "./pages/feed";
import { FeedCollectionPage } from "./pages/feed-collection";
import { HomePage } from "./pages/home";
import { NotFoundPage } from "./pages/not-found";
import { NotificationDetailPage } from "./pages/notification-detail";
import { NotificationsSettingsPage } from "./pages/notifications-settings";
import { ProductPage } from "./pages/product";
import { PromosPage } from "./pages/promos";
import { ChatsPage } from "./pages/chats";
import { AuthOAuthPage } from "./pages/auth-oauth";
import { AccountDeletionPage } from "./pages/account-deletion";
import { ProfileShell } from "@/components/profile/profile-shell";
import { ProfileIndexRedirect } from "./pages/profile/index-redirect";
import { ProfileAddressesPage, ProfileBalancePage, ProfileDevicesPage } from "./pages/profile/legacy-routes";
import { ProfileHistoryPage } from "./pages/profile/history";
import { ProfileLookPage, ProfileLooksPage } from "./pages/profile/looks";
import { ProfileNotificationsPage } from "./pages/profile/notifications";
import { ProfileOrderPage } from "./pages/profile/order-detail";
import { ProfileOrdersPage } from "./pages/profile/orders";
import { ProfilePaymentsPage } from "./pages/profile/payments";
import { ProfilePersonalPage } from "./pages/profile/personal";
import { ProfilePurchaseOrderPage } from "./pages/profile/purchase-order";
import { ProfileReturnPage } from "./pages/profile/return-detail";
import { ProfileReturnsPage } from "./pages/profile/returns";
import { ProfileReviewsPage } from "./pages/profile/reviews";
import { MyPromosPage } from "./pages/my-promos";
import { ProfileSupportPage } from "./pages/profile/support";
import { RequestsPage } from "./pages/requests";
import { ShopPage } from "./pages/shop";
import { ShopInvitePage } from "./pages/shop-invite";
import { SupportPage } from "./pages/support";
import { WishlistPage } from "./pages/wishlist";
import { PayPage } from "@/pages/pay";
import { SearchRedirect } from "./pages/search-redirect";
import { PartnerArticlesPage } from "./pages/partner/articles";
import { PartnerCatalogPage } from "./pages/partner/catalog";
import { PartnerShell } from "./pages/partner/shell";
import { PartnerStatsPage } from "./pages/partner/stats";
export function AppRoutes() {
  const $ = _c(58);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SiteLayout />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Route path="/" element={<HomePage />} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Route path="/ideas" element={<FeedPage />} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Route path="/feed" element={<Navigate to="/ideas" replace={true} />} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Route path="/feed/:slug" element={<FeedCollectionPage />} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Route path="/catalog" element={<CatalogPage />} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Route path="/search" element={<SearchRedirect />} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Route path="/product/:id" element={<ProductPage />} />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Route path="/shop/:slug" element={<ShopPage />} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Route path="/s/:code" element={<ShopInvitePage />} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Route path="/promos" element={<PromosPage />} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Route path="/cart" element={<CartPage />} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Route path="/checkout" element={<CheckoutPage />} />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Route path="/checkout/success" element={<CheckoutSuccessPage />} />;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Route path="/pay/:orderId" element={<PayPage />} />;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Route path="/wishlist" element={<WishlistPage />} />;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Route path="/notifications" element={<Navigate to="/profile/notifications" replace={true} />} />;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Route path="/notifications/settings" element={<Navigate to="/profile/notifications/settings" replace={true} />} />;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Route path="/notifications/:id" element={<NotificationDetailPage />} />;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Route path="/support" element={<SupportPage />} />;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Route path="/delivery" element={<DeliveryPage />} />;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Route path="/contacts" element={<ContactsPage />} />;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Route path="/payment" element={<PaymentPage />} />;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Route path="/returns" element={<ReturnsPage />} />;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Route path="/account-deletion" element={<AccountDeletionPage />} />;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Route path="/refund" element={<Navigate to="/returns" replace={true} />} />;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Route path="/sell" element={<BecomeSellerPage />} />;
    $[26] = t26;
  } else {
    t26 = $[26];
  }
  let t27;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Route path="/chats" element={<ChatsPage />} />;
    $[27] = t27;
  } else {
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Route path="/auth/oauth" element={<AuthOAuthPage />} />;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <ProfileShell />;
    $[29] = t29;
  } else {
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Route index={true} element={<ProfileIndexRedirect />} />;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <Route path="orders" element={<ProfileOrdersPage />} />;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <Route path="orders/:orderId" element={<ProfileOrderPage />} />;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <Route path="notifications" element={<ProfileNotificationsPage />} />;
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Route path="notifications/settings" element={<NotificationsSettingsPage />} />;
    $[34] = t34;
  } else {
    t34 = $[34];
  }
  let t35;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <Route path="personal" element={<ProfilePersonalPage />} />;
    $[35] = t35;
  } else {
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Route path="history" element={<ProfileHistoryPage />} />;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Route path="looks" element={<ProfileLooksPage />} />;
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  let t38;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Route path="looks/:lookId" element={<ProfileLookPage />} />;
    $[38] = t38;
  } else {
    t38 = $[38];
  }
  let t39;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Route path="reviews" element={<ProfileReviewsPage />} />;
    $[39] = t39;
  } else {
    t39 = $[39];
  }
  let t40;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <Route path="purchases" element={<Navigate to="/profile/orders" replace={true} />} />;
    $[40] = t40;
  } else {
    t40 = $[40];
  }
  let t41;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <Route path="purchases/:orderId" element={<ProfilePurchaseOrderPage />} />;
    $[41] = t41;
  } else {
    t41 = $[41];
  }
  let t42;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <Route path="returns" element={<ProfileReturnsPage />} />;
    $[42] = t42;
  } else {
    t42 = $[42];
  }
  let t43;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Route path="returns/:returnId" element={<ProfileReturnPage />} />;
    $[43] = t43;
  } else {
    t43 = $[43];
  }
  let t44;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <Route path="payments" element={<ProfilePaymentsPage />} />;
    $[44] = t44;
  } else {
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <Route path="coupons" element={<MyPromosPage />} />;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <Route path="support" element={<ProfileSupportPage />} />;
    $[46] = t46;
  } else {
    t46 = $[46];
  }
  let t47;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <Route path="balance" element={<ProfileBalancePage />} />;
    $[47] = t47;
  } else {
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <Route path="addresses" element={<ProfileAddressesPage />} />;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  let t49;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <Route path="/profile" element={t29}>{t30}{t31}{t32}{t33}{t34}{t35}{t36}{t37}{t38}{t39}{t40}{t41}{t42}{t43}{t44}{t45}{t46}{t47}{t48}<Route path="devices" element={<ProfileDevicesPage />} /></Route>;
    $[49] = t49;
  } else {
    t49 = $[49];
  }
  let t50;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <PartnerShell />;
    $[50] = t50;
  } else {
    t50 = $[50];
  }
  let t51;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <Route index={true} element={<Navigate to="/partner/catalog" replace={true} />} />;
    $[51] = t51;
  } else {
    t51 = $[51];
  }
  let t52;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <Route path="catalog" element={<PartnerCatalogPage />} />;
    $[52] = t52;
  } else {
    t52 = $[52];
  }
  let t53;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <Route path="articles" element={<PartnerArticlesPage />} />;
    $[53] = t53;
  } else {
    t53 = $[53];
  }
  let t54;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <Route path="stats" element={<PartnerStatsPage />} />;
    $[54] = t54;
  } else {
    t54 = $[54];
  }
  let t55;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <Route path="/partner" element={t50}>{t51}{t52}{t53}{t54}<Route path="*" element={<Navigate to="/partner/catalog" replace={true} />} /></Route>;
    $[55] = t55;
  } else {
    t55 = $[55];
  }
  let t56;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <Route path="/requests" element={<RequestsPage />} />;
    $[56] = t56;
  } else {
    t56 = $[56];
  }
  let t57;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <Routes><Route element={t0}>{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}{t26}{t27}{t28}{t49}{t55}{t56}<Route path="*" element={<NotFoundPage />} /></Route></Routes>;
    $[57] = t57;
  } else {
    t57 = $[57];
  }
  return t57;
}